<template>
    <section>
        <b-overlay :show="loading" rounded="sm">
            <select v-model="showing">
                <option value="9">Top 10</option>
                <option value="4">Top 5</option>
                <option value="2">Top 3</option>
                <option value="all" selected>Show All</option>
            </select>
            <chart :options="chartOptions"  ref="chart"></chart>
            <span>Total de pax:{{totalPax}}</span>
        </b-overlay>
    </section>
</template>

<script>
    import {Chart} from 'highcharts-vue'
    import Highcharts from 'highcharts'
    import exportingInit from 'highcharts/modules/exporting'
    exportingInit(Highcharts)

    export default {
        name: "AveragePaxPerVehicleType",
        components:{Chart},
        props: {
            series: {
                required: true
            },
            categories:{
                required: true
            }
        },
        data(){
            return {
                max:null,
                totalPax:0,
                showing:"all",
                loading:false,
                exporting: {
                    enabled: true
                },
                codeReport : "supplier-stadistics",
                
            }
        },
        methods:{
        },
        computed:{
            chartOptions(){
                return {
                    title: {
                        text: 'Estadisticas de proveedor'
                    },
                    tooltip: {
                        formatter: function(tooltip) {
                            let original = tooltip.defaultFormatter.call(this, tooltip);
                            let detalle   = this.point.details??{};
                            for (let status in detalle ){
                                original.push(status+"= <b>"+detalle[status]+"</b><br/>");
                            }
                            return original;
                        }
                    },
                    yAxis: {
                        title: {
                            text: 'Promedio de pax'
                        }
                    },
                    exporting:{
                        buttons:{
                            menuItems:["viewFullscreen"]
                        }
                    },
                    chart:{
                        type:'column'
                    },
                    xAxis:{
                        type: 'category',
                        categories:this.categories,
                        max:this.max,
                    },
                    series: this.series,
                    plotOptions: {
                        series: {
                            dataLabels: {
                                enabled: true
                            }
                        }
                    }
                }
            }
          
        },
        watch:{
            showing(){
                if(this.showing >0 ){
                    if((this.showing)<= (this.chartOptions.xAxis.categories.length-1) ){
                        this.max= this.showing;
                    }else{
                        this.showing = 'all';
                    }
                }else{
                    this.chartOptions.xAxis.max = null;
                }
            }
        },
        mounted() {
          
        }
    }
</script>

<style scoped>

</style>